let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("6Rih1")]).then(() => parcelRequire('aCUUP'));